export class Budgets {
  constructor() {
    const budgetsList = document.querySelector('.budgets .list-cities');
    budgetsList.querySelector('button')
      .addEventListener('click', () => budgetsList.classList.add('expanded'));
  }
}
